import { normalizeMapLegendSymbol, SYMBOL_LINE } from "./mapLegendSymbols";

export type OperatorMapLegendItem = {
  label: string;
  color: string;
  symbol: string;
};

const DEFAULT_PIPELINE_LABEL = "Pipeline";

function str(v: unknown): string {
  return typeof v === "string" ? v.trim() : "";
}

/**
 * Mobile `OperatorCard` legend — `mapLegendSubform` rows, else `keyColor` + Pipeline.
 */
export function operatorMapLegendItemsFromRecord(
  operator: unknown,
): OperatorMapLegendItem[] {
  if (!operator || typeof operator !== "object") return [];
  const o = operator as Record<string, unknown>;
  const sub = o.mapLegendSubform ?? o.MapLegendSubform;
  if (Array.isArray(sub) && sub.length > 0) {
    const items: OperatorMapLegendItem[] = [];
    for (const row of sub) {
      if (!row || typeof row !== "object") continue;
      const r = row as Record<string, unknown>;
      const label = str(r.label ?? r.Label);
      const color = str(r.color ?? r.Color);
      if (label && color) {
        items.push({
          label,
          color,
          symbol: normalizeMapLegendSymbol(r.symbol ?? r.Symbol),
        });
      }
    }
    if (items.length) return items;
  }
  const keyColor = str(o.keyColor ?? o.KeyColor);
  if (keyColor) {
    return [{ label: DEFAULT_PIPELINE_LABEL, color: keyColor, symbol: SYMBOL_LINE }];
  }
  return [];
}
